export function getMaxValueForNumericStepper(stockInfo) {
  const {
    sellWithoutStockInHands,
    availableQuantity,
    inStoreQuantity,
    otherStoresQuantity,
  } = stockInfo
  return sellWithoutStockInHands
    ? null
    : availableQuantity || inStoreQuantity + otherStoresQuantity
}

export function isItemAvailableToEditQuantity(stockInfo) {
  const { skuIsAvailableAtInitialQuantity, sellWithoutStockInHands } =
    stockInfo || {}

  return sellWithoutStockInHands || skuIsAvailableAtInitialQuantity
}

export function isItemAvailableToAddToCart(stockInfo) {
  const {
    skuIsAvailableAtInitialQuantity,
    hasCheckedInStock,
    hasDeliveryStock,
    hasPickUpStock,
    sellWithoutStockInHands,
  } = stockInfo || {}

  // Always available to add to cart if it can force stock
  if (sellWithoutStockInHands) {
    return true
  }

  // With sku available and with stock in at least one channel, you can add to cart
  return (
    skuIsAvailableAtInitialQuantity &&
    (hasCheckedInStock || hasDeliveryStock || hasPickUpStock)
  )
}

export function isItemWithoutStock(stockInfo) {
  const {
    quantity,
    availableQuantity,
    inStoreQuantity,
    otherStoresQuantity,
  } = stockInfo

  return (
    quantity > inStoreQuantity + otherStoresQuantity &&
    quantity > availableQuantity
  )
}

export function isProductOpen(productInfo) {
  const { isSelectorOpen, isUniqueItem, loading } = productInfo

  return !isSelectorOpen && isUniqueItem && !loading
}
